function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54555A"
    },
    d: "M3.18847 10.08C1.84253 10.08 0.756042 11.2056 0.756042 12.6C0.756042 13.9944 1.84253 15.12 3.18847 15.12C4.53442 15.12 5.62091 13.9944 5.62091 12.6C5.62091 11.2056 4.53442 10.08 3.18847 10.08ZM3.18847 0C1.84253 0 0.756042 1.1256 0.756042 2.52C0.756042 3.9144 1.84253 5.04 3.18847 5.04C4.53442 5.04 5.62091 3.9144 5.62091 2.52C5.62091 1.1256 4.53442 0 3.18847 0ZM3.18847 20.16C1.84253 20.16 0.756042 21.3024 0.756042 22.68C0.756042 24.0576 1.85875 25.2 3.18847 25.2C4.5182 25.2 5.62091 24.0576 5.62091 22.68C5.62091 21.3024 4.53442 20.16 3.18847 20.16ZM8.05334 24.36H30.756V21H8.05334V24.36ZM8.05334 14.28H30.756V10.92H8.05334V14.28ZM8.05334 0.84V4.2H30.756V0.84H8.05334Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.d4e50c0ee3501141552dc0eecc325272.svg";
export { ForwardRef as ReactComponent };